import {
  Injectable
} from '@angular/core';

import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';


import {
  AuthService
} from '../auth';

@Injectable()
export class ManagerGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const self = this;

    console.log('Checking for administrator');
    return this.auth.hasRole('manager') || this.auth.hasRole('administrator');
  }
}
